/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react'
import ReactDOM from 'react-dom'
import { useField, FieldHookConfig } from 'formik'
import { Input, InputProps } from '@bootstrap-styled/v4'
import IMask from 'imask'
import { IMaskMixin as withIMask, IMaskInputProps as IMaskInputPropsOrigin } from 'react-imask'
import { omit } from 'ramda'

// types definition
// eslint-disable-next-line @typescript-eslint/interface-name-prefix
type IMaskInputProps = Omit<InputProps, keyof IMaskInputPropsOrigin | 'ref'> & {
    inputRef?: React.Ref<HTMLInputElement>
}

export interface InputMaskProps
    extends IMaskInputPropsOrigin,
        Omit<IMaskInputProps, 'name'>,
        Pick<FieldHookConfig<any>, 'name'> {}

/**
 * Input component to wrap within IMaskMixin decorator function
 * @component React function component
 */
const InputComponent: React.FC<IMaskInputProps> = ({ inputRef, ...props }) => {
    const inputEl = useRef<HTMLInputElement | null>(null)

    return (
        <Input
            {...props}
            ref={node => {
                // eslint-disable-next-line react/no-find-dom-node
                const nodeEl = ReactDOM.findDOMNode(node) as HTMLInputElement | null
                inputEl.current = nodeEl

                if (typeof inputRef === 'function') {
                    inputRef(nodeEl)
                }
            }}
        />
    )
}
export const IMaskInput = withIMask<IMaskInputProps, HTMLInputElement>(InputComponent)

/**
 * Input mask component
 * @component React function component
 */
const InputMask: React.FC<InputMaskProps> = ({ name, onAccept, onComplete, ...props }) => {
    const [field, meta, helpers] = useField({ name })

    // Event handlers
    const handleInputMask = (
        value: string,
        mask: InstanceType<typeof IMask.InputMask>,
        ...args: any[]
    ): void => {
        helpers.setValue(value)

        if (onAccept) {
            onAccept(value, mask, ...args)
        }
    }

    const handleCompleteMask = (
        value: string,
        mask: InstanceType<typeof IMask.InputMask>,
        ...args: any[]
    ): void => {
        helpers.setValue(value)

        if (onComplete) {
            onComplete(value, mask, ...args)
        }
    }

    return (
        <IMaskInput
            onAccept={handleInputMask}
            onComplete={handleCompleteMask}
            {...omit(['onChange'], field)}
            {...props}
        />
    )
}

export default InputMask
